/**
 * @generated SignedSource<<da7bc2cfc2131105ff3ce96b4c789ac2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskListItemTitle_Task$data = {
  readonly title: string;
  readonly " $fragmentType": "TaskListItemTitle_Task";
};
export type TaskListItemTitle_Task$key = {
  readonly " $data"?: TaskListItemTitle_Task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskListItemTitle_Task">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskListItemTitle_Task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": "__isTask"
};

(node as any).hash = "b166997c883c9c447d0fe036104ec0e9";

export default node;
